// extracted by mini-css-extract-plugin
export default {"loadingMessageContainer":"Activities_loadingMessageContainer__WLj7Q","btnAddMain":"Activities_btnAddMain__oNNV2","topbarflex":"Activities_topbarflex__pEs49"};